import {
  type JSX,
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  CadClickCadBox,
  CadClickCadBoxProps,
} from "@plansoft-configuration-renderer/components";
import {
  useConfigurationApi,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";

// const CadClickCadBoxLazy = lazy(() => import("./CadClickCadBox"));

export function CustomCadClickCadBox(props: CadClickCadBoxProps): JSX.Element {
  const api = useConfigurationApi();
  const sessionId = useSessionId();

  const [cadTemplate, setCadTemplate] = useState<string>("");

  const getCadTemplate = useCallback(async () => {
    try {
      const res = await api.invokeUserDefinedGetter({
        id: sessionId,
        name: "getCadTemplate",
        invokeUserDefinedGetterParams: {
          path: "/XAS_PRODUCT_VIEW/0/",
          input: JSON.stringify({}),
        },
      });

      if (res?.output) {
        setCadTemplate(res.output);
      }
    } catch (error) {
      console.error('Error in invokeUserDefinedGetter "getCadTemplate"', error);
    }
  }, [api, sessionId]);

  useEffect(() => {
    getCadTemplate();
  }, [getCadTemplate]);

  const memoizedExport = useMemo(
    () => ({
      ...props.export,
      pdf3d: {
        layout: cadTemplate,
        zipAllFiles: props.export?.pdf3d?.zipAllFiles ?? true,
        zipIfMultipleFiles: props.export?.pdf3d?.zipIfMultipleFiles ?? true,
      },
      dimensionalDrawing: {
        layout: cadTemplate,
        zipAllFiles: props.export?.dimensionalDrawing?.zipAllFiles ?? true,
        zipIfMultipleFiles:
          props.export?.dimensionalDrawing?.zipIfMultipleFiles ?? true,
      },
    }),
    [props.export, cadTemplate],
  );
  if (!cadTemplate) {
    return <></>;
  }
  return (
    <Suspense>
      {/* <CadClickCadBoxLazy {...props} /> */}
      <CadClickCadBox {...props} export={memoizedExport} />
    </Suspense>
  );
}
